<template>
  <div class="index">
    <section class="mainHead">
      <b-img
        :src="require('@/assets/imgs/index_main.jpg')"
        fluid
        alt=""
      ></b-img>
    </section>
    <section class="indexVideo">
      <b-container>
        <b-row align-h="center">
          <b-col cols="12" lg="8">
            <h3 class="font-weight-bold text-center">{{ $t("index_title") }}</h3>
          </b-col>
          <b-col cols="12" lg="6">
            <h4 class="text-center">English</h4>
            <div class="video-container">
              <iframe
                src="https://www.youtube.com/embed/0UeISKrJeFM"
                title="2026 International Forum on Taiwan Cultural Heritage: Shuei-Jin-Jiou Mining Sites"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </b-col>
          <b-col cols="12" lg="6">
            <h4 class="text-center">中文</h4>
            <div class="video-container">
              <iframe
                src="https://www.youtube.com/embed/AlmUYwFPYXU"
                title="2026年臺灣文化遺產國際論壇 | 礦脈未眠，歲月仍在山城流動"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="mainContent">
      <b-container>
        <b-row align-h="center">
          <!-- <b-col cols="12" lg="8">
             <h3 class="font-weight-bold">{{ $t("index_title") }}</h3>
             <b-row>
              <b-col cols="12" lg="6">
                <h4>9/5</h4>
                <div class="video-container">
                  <iframe
                    :src="videoUrl_0925"
                    title="International Forum on Taiwan Cultural Heritage 2025 (9/5)"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </div>
              </b-col>
              <b-col cols="12" lg="6">
                <h4>9/6</h4>
                <div class="video-container">
                  <iframe
                    :src="videoUrl_0926"
                    title="International Forum on Taiwan Cultural Heritage 2025 (9/6)"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </div>
              </b-col>
             </b-row>
          </b-col> -->
          <b-col cols="12" lg="8">
             <h3 class="font-weight-bold about-title">{{ $t("index_about_title") }}</h3>
             <p>{{ $t("index_about_01") }} <strong>{{ $t("index_about_02") }}</strong>{{ $t("index_about_03") }}</p>
          </b-col>
          <b-col cols="12" lg="8" class="my-4">
             <h3 class="font-weight-bold">{{ $t("Date&Venue") }}</h3>
             <div class="d-flex">
              <div style="white-space: nowrap">{{ $t("DateTitle") }}</div>
              <div class="ml-1">{{ $t("Date") }}</div>
             </div>
             <div class="d-flex">
              <div style="white-space: nowrap">{{ $t("VenueTitle") }}</div>
              <div class="ml-1">{{ $t("Venue") }}{{ $t("Venue2") }}<br><small>{{ $t("Venue3") }}</small></div>
             </div>
             <div class="home-notice-card" v-if="$t('Tip_1')" v-html="$t('Tip_1')"></div>
          </b-col>
          <b-col cols="12" lg="8" class="my-4 gift-section">
          <h3 class="font-weight-bold">{{ $t("gift_title") }}</h3>

             <div class="gift-item gift-item-featured">
               <div class="gift-copy">
                 <span class="gift-step">01</span>
                 <h4 class="gift-title">{{ $t("gift_early_title") }}</h4>
                 <p v-html="$t('gift_early_description')"></p>
               </div>
               <figure class="gift-figure">
                 <span class="gift-badge">{{ $t("gift_early_badge") }}</span>
                 <div class="gift-figure-media gift-figure-media-compact gift-figure-media-01">
                   <b-img :src="require('@/assets/imgs/img_gift01.jpg')" fluid :alt="$t('gift_early_alt')"></b-img>
                 </div>
                 <figcaption>{{ $t("gift_early_name") }}</figcaption>
               </figure>
             </div>

             <div class="gift-item">
               <div class="gift-copy">
                 <span class="gift-step">02</span>
                 <h4 class="gift-title">{{ $t("gift_feedback_title") }}</h4>
                 <p>{{ $t("gift_feedback_description") }}</p>
               </div>
               <b-row class="gift-list">
                 <b-col cols="12">
                   <figure class="gift-figure">
                     <span class="gift-badge">{{ $t("gift_glass_badge") }}</span>
                     <div class="gift-figure-media gift-figure-media-compact gift-figure-media-02">
                       <b-img :src="require('@/assets/imgs/img_gift03.png')" fluid :alt="$t('gift_glass_alt')"></b-img>
                     </div>
                     <figcaption>{{ $t("gift_glass_name") }}</figcaption>
                   </figure>
                 </b-col>
                 <b-col cols="12">
                   <figure class="gift-figure">
                     <span class="gift-badge">{{ $t("gift_pack_badge") }}</span>
                     <div class="gift-figure-media gift-figure-media-compact gift-figure-media-02">
                       <b-img :src="require('@/assets/imgs/img_gift02.png')" fluid :alt="$t('gift_pack_alt')"></b-img>
                     </div>
                     <figcaption>{{ $t("gift_pack_name") }}<small>{{ $t("gift_pack_details") }}</small></figcaption>
                   </figure>
                 </b-col>
               </b-row>
             </div>

             <div class="gift-notes">
               <h4>{{ $t("gift_notes_title") }}</h4>
               <ol>
                 <li>{{ $t("gift_note_1") }}</li>
                 <li>{{ $t("gift_note_2") }}</li>
                 <li>{{ $t("gift_note_3") }}</li>
               </ol>
             </div>

          </b-col>

        </b-row> 

        <b-row align-h="center">
          <b-col cols="auto">
            <b-link to="About" class="btn mainBtn">{{ $t("more_btn") }}</b-link>
          </b-col>
        </b-row>     
      </b-container>
    </section>



    <ul id="myMenu">
      <li>
        <a
          href="https://www.surveycake.com/s/DrWBR"
          target="_blank"
          tooltip="報名論壇"
          flow="left"
          :title="$t('rightNav02-1')"
          ><span class="icon-user-plus"></span>
          <span class="sr-only">{{ $t("TopNav05") }}</span></a
        >
      </li>
      <li>
        <a
          href="javascript:"
          v-scroll-to="'#top'"
          :title="$t('rightNav07')"
          ><span class="icon-arrow_up"></span><span class="sr-only">top</span></a
        >
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "Home",
    components: {},
    computed: {
    videoUrl_0925() {
      const language = sessionStorage.getItem('language');
      if (language === 'EN') {
        return 'https://www.youtube.com/embed/fzWRFx6SsF8?si=WNiPcNGbf8LfADQF';
      } else if (language === 'ZH') {
        return 'https://www.youtube.com/embed/F288jrrOtZs?si=tEtV6wQ9ra-R_7od';
      } else {
        return 'https://www.youtube.com/embed/F288jrrOtZs?si=tEtV6wQ9ra-R_7od';
      }
    },
    videoUrl_0926() {
      const language = sessionStorage.getItem('language');
      if (language === 'EN') {
        return 'https://www.youtube.com/embed/IYlyH6-a4lA?si=xpxhR5-WFIyokGEt';
      } else if (language === 'ZH') {
        return 'https://www.youtube.com/embed/vjhjMxSiZrM?si=rJbKlzc78xFkmRi8';
      } else {
        return 'https://www.youtube.com/embed/vjhjMxSiZrM?si=rJbKlzc78xFkmRi8';
      }
    },

  },

  };
</script>

<style>
  .test {
    display: none;
  }

  .gift-section {
    --gift-gold: #b78f52;
    --gift-gold-dark: #8c6630;
    --gift-green: #244e47;
    --gift-cream: #fbf7ef;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .gift-heading {
    position: relative;
    overflow: hidden;
    margin-bottom: 1.5rem;
    padding: 1.5rem 1.75rem;
    border-radius: 18px;
    color: #fff;
    background: linear-gradient(125deg, var(--gift-green) 0%, #397267 100%);
    box-shadow: 0 12px 30px rgba(36, 78, 71, 0.2);
  }

  .gift-heading::after {
    content: "禮";
    position: absolute;
    right: 1rem;
    top: 50%;
    color: rgba(255, 255, 255, 0.08);
    font-size: 8rem;
    font-weight: 900;
    line-height: 1;
    transform: translateY(-50%);
  }

  .gift-heading-label {
    color: #edd4a7;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.18em;
  }

  .gift-heading h3 {
    position: relative;
    z-index: 1;
    margin: 0.2rem 0 0.35rem;
    font-size: 2rem;
  }

  .gift-heading p {
    position: relative;
    z-index: 1;
    margin: 0;
    color: rgba(255, 255, 255, 0.9);
  }

  .gift-item {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1.25fr) minmax(220px, 0.75fr);
    gap: 1.5rem;
    align-items: center;
    margin-top: 1.25rem;
    padding: 1.5rem;
    border: 1px solid rgba(183, 143, 82, 0.28);
    border-radius: 18px;
    background: linear-gradient(145deg, #fff 0%, var(--gift-cream) 100%);
    box-shadow: 0 8px 24px rgba(73, 57, 33, 0.1);
  }

  .gift-copy {
    position: relative;
    padding-left: 3.5rem;
  }

  .gift-step {
    position: absolute;
    left: 0;
    top: -0.15rem;
    display: inline-flex;
    width: 2.7rem;
    height: 2.7rem;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #fff;
    background: var(--gift-gold);
    box-shadow: 0 5px 12px rgba(183, 143, 82, 0.28);
    font-size: 0.9rem;
    font-weight: 800;
  }

  .gift-title {
    margin-bottom: 0.55rem;
    color: var(--gift-green);
    font-size: 1.35rem;
    font-weight: 800;
  }

  .gift-copy p {
    margin-bottom: 1.25rem;
    line-height: 1.8;
  }

  .gift-copy strong {
    color: var(--gift-gold-dark);
    font-size: 1.08em;
  }

  .gift-list {
    margin-top: 0.25rem;
  }

  .gift-figure {
    position: relative;
    overflow: hidden;
    width: 75%;
    height: calc(100% - 1rem);
    margin: 0 auto 1rem;
    padding: 0.65rem;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 5px 18px rgba(44, 55, 50, 0.12);
  }

  .gift-figure img {
    width: 100%;
    border-radius: 9px;
    transition: transform 0.35s ease;
  }

  .gift-figure-media-compact {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .gift-figure-media-compact img {
    width: 55%;
  }

  .gift-figure-media-01 {
    aspect-ratio: 1024 / 682;
  }

  .gift-figure-media-02 {
    aspect-ratio: 800 / 400;
  }

  .gift-figure:hover img {
    transform: scale(1.025);
  }

  .gift-badge {
    position: absolute;
    z-index: 2;
    top: 1rem;
    right: 1rem;
    padding: 0.35rem 0.7rem;
    border-radius: 999px;
    color: #fff;
    background: #b64f3c;
    box-shadow: 0 4px 10px rgba(107, 39, 26, 0.25);
    font-size: 0.82rem;
    font-weight: 700;
  }

  .gift-figure figcaption {
    margin-top: 0.75rem;
    color: var(--gift-green);
    text-align: center;
    font-weight: 700;
  }

  .gift-figure figcaption small {
    display: block;
    margin-top: 0.2rem;
    color: #706c64;
    font-weight: 400;
  }

  .gift-notes {
    margin-top: 1.25rem;
    padding: 1.1rem 1.25rem 1.1rem 1.5rem;
    border-left: 5px solid var(--gift-gold);
    border-radius: 0 12px 12px 0;
    background: #f6f1e7;
  }

  .gift-notes h4 {
    margin-bottom: 0.65rem;
    color: var(--gift-gold-dark);
    font-size: 1.15rem;
    font-weight: 800;
  }

  .gift-notes ol {
    margin: 0;
    padding-left: 1.5rem;
  }

  .gift-notes li + li {
    margin-top: 0.35rem;
  }

  @media (max-width: 767.98px) {
    .gift-heading {
      padding: 1.25rem;
      border-radius: 14px;
    }

    .gift-heading h3 {
      font-size: 1.7rem;
    }

    .gift-heading::after {
      font-size: 6rem;
    }

    .gift-item {
      display: block;
      padding: 1rem;
      border-radius: 14px;
    }

    .gift-copy {
      padding-left: 3.15rem;
    }

    .gift-item .gift-figure {
      margin-top: 0.5rem;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .gift-figure img {
      transition: none;
    }
  }

  .home-notice-card {
    margin-top: 1rem;
    padding: 1rem 1.5rem;
    border-left: 5px solid #b64f3c;
    border-radius: 0 12px 12px 0;
    background: #fdf1ee;
    color: #555;
    line-height: 1.8;
    text-align: left;
  }

  .home-notice-card p {
    margin: 0;
  }
</style>
